export const text = {
    pageTitle: "GPT",
    errorMsg: "مشکلی پیش آمده، لطفا دوباره تلاش کنید.",
}